import React, { ReactElement } from 'react'

import Employee from '../../../model/employee'
import { EmployeeReducer } from '../../../reducers/employees'
import { FormComponentProps, withValidations } from '../../../utils/form-utils'
import { setByPath } from '../../../utils/object-utils'
import PaySlipsTransport from '../../employees-single/pay-slips/PaySlipsTransport'
import LoadingOverlay from '../../widgets/LoadingOverlay'

// NEED_NO_TRANSLATION

type Props = {
  employee: Employee
  employees: EmployeeReducer
  hasPremiumPackage: boolean
}

export type PaySlipFields = {
  paySlipTransportMitDK: boolean
  paySlipTransportEBoks: boolean
  paySlipTransportEMail: boolean
  paySlipTransportSMS: boolean
}

function PayInvoicesForm(props: Props & FormComponentProps<PaySlipFields, PaySlipFields>): ReactElement | null {
  return (
    <div className="employees-single-form">
      <PaySlipsTransport
        hasNationalID={props.employee.nationalIDType !== 'DK No CPR'}
        hasPremiumPackage={props.hasPremiumPackage}
        hasEmail={!!props.employee.email}
        isFreelancer={true}
        decorateField={props.decorateField}
      />
      {props.employees.saving && <LoadingOverlay />}
    </div>
  )
}

export default withValidations<Props, PaySlipFields, PaySlipFields>({
  mapPropsToFields: (props) => ({
    paySlipTransportMitDK: props.employee.paySlipTransportMitDK,
    paySlipTransportEBoks: props.employee.paySlipTransportEBoks,
    paySlipTransportEMail: props.employee.paySlipTransportEMail,
    paySlipTransportSMS: false,
  }),
  onChange: (key, val) => {
    const values: Partial<PaySlipFields> = {}
    switch (key) {
      case 'paySlipTransportMitDK':
        values.paySlipTransportEBoks = false
        break
      case 'paySlipTransportEBoks':
        values.paySlipTransportMitDK = false
        break
    }
    setByPath(values, key, val)
    return values
  },
  submitOnChange: true,
  onSubmit: (values) => values,
})(PayInvoicesForm)
